import { GroundCommonContent } from "../GroundCommonContent/GroundCommonContent";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div className="grid min-w-0 overflow-hidden bg-charcoal-green-ink md:min-h-[42rem] md:grid-cols-[0.9fr_1.1fr]">
    <GroundMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="h-full min-h-80 min-w-0 w-full md:order-2"
      imageClassName="h-full object-cover transition-transform duration-300 ease-out hover:scale-[1.015]"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <GroundCommonContent
      alignment={alignment}
      buttons={buttons}
      className="min-w-0 justify-center p-7 md:order-1 md:p-12 lg:p-16"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="text-[clamp(1.875rem,9.25vw,5.5rem)] md:text-7xl lg:text-8xl"
      tone="dark"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
